import { Component, ViewChild, ChangeDetectorRef, OnInit   } from '@angular/core';
import { NavController, MenuController, Nav, Platform, Events, ModalController, AlertController, LoadingController, Loading, DateTime } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { Storage } from '@ionic/storage';
import { Page } from '../enums/page.enum';

import { Tabs } from '../pages/tabs/tabs';
import { Login } from '../pages/login/login';
import { Customer } from '../pages/customer/customer';
import { Product } from '../pages/product/product';
import { OrderList } from '../pages/order-list/order-list';
import { TxnHistory } from '../pages/txn-history/txn-history';
import { TrackOrder } from '../pages/track-order/track-order';
import { UserProfile } from '../pages/user-profile/user-profile';
import { Salesrep } from '../pages/salesrep/salesrep';
import { CustomerSearchPage } from '../pages/customer-search/customer-search'

import { NotificationMessageType } from '../enums/notificationMessageType.enum'
import { SSEConnectionStatus } from '../enums/sseconnectionstatus.enum';

/* Models */
import { PageModel } from '../models/page.model';
import { SalesrepModel } from '../models/user/salesrep.model';
import { OrderHeaderModel } from '../models/order/orderheader.model';
import { NotificationModel } from '../models/notifiction.model';
/* Filters & Services */
import { UserService } from '../services/user.service';
import { UtilService } from '../services/util.service';
import { BadgeService } from '../services/badge.service';
import { StorageService } from '../services/storage.service';
import { Errors } from '../services/apperror';
import { Setups } from '../services/setup';
import * as _ from "lodash";
//import { AuthService } from '../services/auth.service';
import { CustomerService } from '../services/customer.service';
import { MsalService, MsalBroadcastService } from '@azure/msal-angular';
import { InteractionStatus, EventType, InteractionRequiredAuthError, BrowserUtils, EventMessage } from '@azure/msal-browser';
import { filter, takeUntil, catchError, take } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { ENV } from '../environment/environment';
import { ModalAction } from '../enums/modalaction.enum';
import { AuthWrapper } from '../infra/authWrapper';
import { ImpersonateWrapper } from '../infra/impersonateWrapper';
import { ImpersonatePage } from '../pages/impersonate/impersonate';
import { UserModel } from '../models/user/user.model';
import { UserType } from '../enums/usertype.enum'
import { Title } from '@angular/platform-browser';


@Component({
  templateUrl: 'app.html'
})
export class MyApp implements OnInit {
  rootPage: any;
  @ViewChild(Nav) nav: Nav;
  salesrepList: SalesrepModel[];
  loading: Loading;
  order: OrderHeaderModel = <OrderHeaderModel>{};
  appPages: PageModel[];
  private readonly _destroying$ = new Subject<void>();
  isImpersonate: boolean = false;
  private eventSource: EventSource | null = null;
  private messageQueue: any[] = [];
  private maxMessages = 50; // Prevent infinite message accumulation
  isRedirectFromMSEntraId: boolean = false;

  constructor(
    private storage: Storage
    , private platform: Platform
    , private menu: MenuController
    , public modalCtrl: ModalController
    , private statusBar: StatusBar
    , private changeDetectorRef: ChangeDetectorRef
    , private events: Events
    , private alertCtrl: AlertController
    , private loadingCtrl: LoadingController
    , private userService: UserService
    , private util: UtilService
    , private badgeService: BadgeService
    , private storageService: StorageService
    , public setups: Setups
    , private msalService: MsalService
    , private impersonateWrapper: ImpersonateWrapper
    , private titlePlatform: Title
    , private authService: MsalService
  ) {
    this.rootPage = 'HomePage';

    this.isRedirectFromMSEntraId = (window.location.href.includes('code=') && window.location.href.includes('session_state='));

    platform.ready().then(() => {
      // Okay, so the platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need.
      this.statusBar.styleDefault();
      this.statusBar.hide();
      // Keyboard.disableScroll(false);
      this.menu = menu;

      if (this.util.isRemoveDKSHLogoForVN()) {
        this.titlePlatform.setTitle('EasyOrder');
      } else {
        this.titlePlatform.setTitle('DKSH EasyOrder');
      }

      events.subscribe('user:loggedin', (user: UserModel) => {
        let isAllowAdhocCustomerInsertion = false;
        const adHocSetup = user.setup_list.find(obj => {
          return obj.setup_code === this.setups.AllowAdhocCustomerInsertion.ID
        });

        if (adHocSetup === null || adHocSetup === undefined) {
          isAllowAdhocCustomerInsertion = false;
        } else {
          isAllowAdhocCustomerInsertion = adHocSetup.setup_value === "0" ? false : true;
        }

        this.isImpersonate = this.impersonateWrapper.isOnImpersonateMode(user);

        this.appPages = [
          { id: 'menu-home', title: 'Home', component: Tabs, tabComponent: Customer, index: Page.CustomerList, icon: 'home', isVisible: user.accessright_list[0].visible == '0' ? false : true, isDisplay: true },
          { id: 'menu-order', title: 'Order', component: Tabs, tabComponent: OrderList, index: Page.OrderList, icon: 'clipboard', salesInd: 'S', isVisible: user.accessright_list[2].visible == '0' ? false : true, isDisplay: true },
          { id: 'menu-foc-order', title: 'FOC order', component: Tabs, tabComponent: OrderList, index: Page.OrderList, icon: 'gift', salesInd: 'F', isVisible: user.accessright_list[3].visible == '0' ? false : true, isDisplay: true },
          { id: 'menu-cog-order', title: 'Consignment order', component: Tabs, tabComponent: OrderList, index: Page.CustomerList, icon: 'codepen', salesInd: 'C', isVisible: user.accessright_list[8].visible == '0' ? false : true, isDisplay: true },
          { id: 'menu-connect-client-url', title: 'Connect Client', component: '', tabComponent: '', index: -1, icon: 'globe', isVisible: false, isDisplay: true}, //TODO: ConnectClient implement SSO
          { id: 'menu-mng-cust', title: 'Manage Customer', component: Tabs, tabComponent: CustomerSearchPage, index: Page.CustomerSearchPage, icon: 'users', isVisible: isAllowAdhocCustomerInsertion, isDisplay: true },
          { id: 'menu-search-prd', title: 'Search product', component: Tabs, tabComponent: Product, index: Page.ProductList, icon: 'dropbox', isVisible: user.accessright_list[1].visible == '0' ? false : true, isDisplay: true },
          { id: 'menu-trans-hist', title: 'Transaction history', component: Tabs, tabComponent: TxnHistory, index: Page.TransactionHistList, icon: 'pencil', isVisible: user.accessright_list[5].visible == '0' ? false : true, isDisplay: true },
          { id: 'menu-order-status', title: 'Order status', component: Tabs, tabComponent: TrackOrder, index: Page.OrderStatusList, icon: 'truck', isVisible: user.accessright_list[4].visible == '0' ? false : true, isDisplay: true },
          { id: 'menu-user-profile', title: 'User Profile', component: Tabs, tabComponent: UserProfile, index: Page.UserProfile, icon: 'user', isVisible: true, isDisplay: true },
          { id: 'menu-change-salesrep', title: 'Change Salesrep', component: Salesrep, tabComponent: Salesrep, index: -1, icon: 'cogs', isVisible: user.accessright_list[6].visible == '0' ? false : true, isDisplay: true },
          { id: 'menu-change-impersonate', title: 'Change Impersonate', component: ImpersonatePage, tabComponent: ImpersonatePage, index: -1, icon: 'id-card', isVisible: true, isDisplay: this.isImpersonate },
          { id: 'menu-logout', title: 'Logout', component: Login, tabComponent: Login, index: -1, icon: 'sign-out', isVisible: true, isDisplay: true },
        ];
      });

      // Did not proceed impersonate mode
      events.subscribe('no-impersonate', (user: UserModel) => {
        let allowSwitchImpersonate = (user.user_type_id === UserType.SUPER_ADMIN || user.user_type_id === UserType.SUPPORT) ? true : false
        this.appPages = [
          { id: 'menu-connect-client-url', title: 'Connect Client', component: '', tabComponent: '', index: -1, icon: 'globe', isVisible: false, isDisplay: true}, //TODO: ConnectClient implement SSO
          { id: 'menu-change-impersonate', title: 'Change Impersonate', component: ImpersonatePage, tabComponent: ImpersonatePage, index: -1, icon: 'id-card', isVisible: allowSwitchImpersonate, isDisplay: allowSwitchImpersonate },
          { id: 'menu-logout', title: 'Logout', component: Login, tabComponent: Login, index: -1, icon: 'sign-out', isVisible: true, isDisplay: true },
        ];
      });

      // Did not have access
      events.subscribe('no-access', () => {
        this.nav.setRoot('UnauthorizedPage');
      });

      this.userService.getLatestAppInformation().then(
        (res) => {
          this.storage.set('notice_message', res.data[1].Value);
          this.storage.set('environment', res.data[0].Value);          
          this.storage.set('google_map_key', res.data[6].Value);
          const script = document.createElement('script');
          script.src = "https://maps.google.com/maps/api/js?key=" + res.data[6].Value;
          document.body.appendChild(script);
          const deployment_flag = res.data[5].Value;

          const lastUpdate: string = res.data[4].Value.substring(0, 10);
          this.storage.set('last_update', lastUpdate);

          this.msalService.instance.enableAccountStorageEvents();
          this.msalService.instance.addEventCallback((event: EventMessage) => {
            switch (event.eventType) {
              case EventType.ACQUIRE_TOKEN_FAILURE:
                console.log("Acquire token error");
                break;
              case EventType.ACCOUNT_REMOVED:
                alert("You signed out from another location. For your security, please close all browser tabs from DKSH.");
                break;
            }
          });

          this.msalService.instance.handleRedirectPromise().then(
            (response) => {
              if (response) {
                this.msalService.instance.setActiveAccount(response.account);
                this.onAuthenticatedNavigate(deployment_flag, response.account.idTokenClaims.preferred_username);
              } else {
                const activeAccount = this.msalService.instance.getActiveAccount();

                if (activeAccount) {
                  this.onAuthenticatedNavigate(deployment_flag, activeAccount.idTokenClaims.preferred_username);
                } else {
                  this.msalService.loginRedirect({
                    scopes: ENV.apiConfig.scopes
                  });
                }
              }
            }
          ).catch(e => {
            console.log(e);
          }
          ); // end of handleRedirectPromise
        }
      ); // end of userService.getLatestAppInformation
    }); // end of platform.ready()
  }

  private onAuthenticatedNavigate(deployment_flag: any, email: string) {
    if (deployment_flag === "1") {
      this.nav.setRoot('MaintenancePage');
    } else {
      this.userService.checkingEmail(email).subscribe(
        (res) => {
          if (res.data) {
            this.nav.setRoot('Login', email);
          } else {
            this.storage.set('AuthenticationType', 'sso').then(
                () => {
                    this.nav.setRoot('SessionContextSetupPage');
                }
            );
          }
        }, (err) => {
          this.util.displayAlert(this.alertCtrl, "Error", "Can not proceed");
        }
      );
    }
  }

  /**
   * Burger menu
   * @param page 
   */
  openPage(page: PageModel) {
    this.appPages.forEach((value) => {
      value.color = "";
    });

    if (page.component.name === 'Tabs') {
      page.color = 'dksh-iconic-red';
      this.changeDetectorRef.detectChanges();
      if (page.salesInd != undefined)
        this.events.publish('change-tab-params', page.index, { salesInd: page.salesInd });
      else
        this.events.publish('change-tab', page.index);
    } else if (page.component.name === 'Salesrep') {
      this.retrieveUserSalesrepList();
    } else if (page.component.name === 'Login') {
      this.events.publish('update-order-detail', "stop");
      this.storage.clear();
      const activeAccount = this.msalService.instance.getActiveAccount();

      if (activeAccount) {
        this.msalService.logoutRedirect({postLogoutRedirectUri: ENV.apiConfig.postLogoutRedirectUri});
      } else {
        window.location.reload();
      }
      
    } else if (page.component.name === 'ImpersonatePage') {
      this.storage.clear();
      window.location.reload();
    }

    if (page.id === 'menu-connect-client-url') {
      window.open(ENV.redirectConfig.connectClientUrl, '_blank');
    }
  }

  retrieveUserSalesrepList() {
    this.loading = this.util.displayLoading(this.loading, this.loadingCtrl, "Loading salesrep list..");
    this.userService.retrieveUserSalesrepList(this.storageService.getUserId(), this.storageService.getSettingId()).subscribe(
      (data) => {
        if (data) {
          if (data.length === 0) {
            this.util.displayAlert(this.alertCtrl, Errors.UserNoSalesrep.Title, Errors.UserNoSalesrep.Message);
            return;
          }

          let salesrepLst: SalesrepModel[] = [];
          
          if (data.length === 1) {
            salesrepLst = _.clone(data.salesrep_list);
            this.clearOrder(salesrepLst);
          } else {
            let salesrepModal = this.modalCtrl.create('Salesrep',
              { data: data, isAllowDismiss: true },
              { enableBackdropDismiss: false }
            );
            salesrepModal.present();

            salesrepModal.onDidDismiss((modalReturnData) => {
              switch (modalReturnData.action) {
                case ModalAction.Cancel:
                  return;
                case ModalAction.Proceed:
                  salesrepLst = _.clone(modalReturnData.salesrep);
                  this.storage.get("order").then((value) => {
                    this.order = value ? value : <OrderHeaderModel>{};
                    if (!_.isEmpty(this.order) 
                        && !_.isEmpty(this.order.detail.length)
                        && !this.util.compareSalesrep(data.salesrep_code, this.storageService.getSalesrepCode())) {
                        this.displayConfirmation("Confirmation", "You've have pending order from previous salesrep. Do you wish to choose this salesrep instead? Any unsaved order will be lost.", data.salesrep);
                    } else {
                      this.clearOrder(salesrepLst);
                    }
                  });
              }
            })
          }
        }
      },
      (err) => {
        this.util.processError(this.loading, this.alertCtrl, err);
      },
      () => {
        this.loading.dismiss();
      }
    )
  }

  displayConfirmation(title: string, message: string, salesrep: SalesrepModel[]) {
    let arrButtons = [{ text: 'Cancel', role: 'cancel', handler: () => { return true; } },
    {
      text: 'Confirm', handler: () => {
        this.clearOrder(salesrep);
      }
    }]
    this.util.displayConfirmation(this.alertCtrl, title, message, arrButtons);
  }

  /**
   * Clear order and setting new salesrep, setup list
   */
  private clearOrder(salesrepLst: SalesrepModel[]) {
    let user = this.storageService.getUser();
    this.userService.retrieveSalesrepSetupList(salesrepLst[0].salesrep_code, user.setting_id).subscribe(
      (setupRes) => {
        user.setup_list.length = 0;
        user.setup_list = _.clone(setupRes);
        user.salesrep_list.length = 0;
        user.salesrep_list = _.clone(salesrepLst);

        this.storageService.setUser(user);
        this.badgeService.resetBadge();
        this.storageService.clearCustomer();
        window.location.reload();
    });
  }

  ngOnInit() {
    this.connectToEventSource();
  }

  private connectToEventSource() {
    if (this.eventSource) {
      // Close any existing connection before reconnecting
      this.eventSource.close(); 
    }
  
    const url = `${location.protocol}${this.util.getWebServiceURL()}notification/ReceiveDeploymentNotification`;
    this.eventSource = new EventSource(url);

    this.eventSource.onopen = (event) => {
      console.log("Establishing connection...");
    }
  
    this.eventSource.onmessage = (event) => {
      try {
        let notification: NotificationModel = JSON.parse(event.data);
        this.displayDeploymentNotification(notification);
      } catch (error) {
        // No need to catch error of keep-alive data
      }
    };
  
    this.eventSource.onerror = (error) => {
      console.error("SSE error:", error);
      this.handleReconnect();
    };

    // Auto-reconnect after 10 mins
    setTimeout(() => {
      console.log("Re-establishing connection after 10 mins...");
      this.eventSource.close();
      this.connectToEventSource();
    }, 10 * 60 * 1000);
  }

  private handleReconnect() {
    if (this.eventSource) {
      this.eventSource.close();
    }
  
    // Wait 5 seconds before reconnecting to avoid excessive requests
    setTimeout(() => {
      this.connectToEventSource();
    }, 5000);
  }

  private displayDeploymentNotification(notification: NotificationModel) {
    if (notification.messageType === NotificationMessageType.PreDeployment) {
      this.util.displayAlert(this.alertCtrl, "System maintenance", notification.message);
    } else if (notification.messageType === NotificationMessageType.PostDeployment) {
      alert(notification.message);
      window.location.reload();
    } else if (notification.messageType === NotificationMessageType.EnableMessage) {
      this.storage.set('notice_message', notification.message);
      this.events.publish('display-warning-notification', true, notification.message);
    } else if (notification.messageType === NotificationMessageType.DisableMessage) {
      this.storage.set('notice_message', '');
      this.events.publish('display-warning-notification', false, '');
    }
  }

  ngOnDestroy() {
    if (this.eventSource) {
      this.eventSource.close();
    }
    this._destroying$.next(undefined);
    this._destroying$.complete();
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts